module.exports = __webpack_public_path__ + "img/1-8.f185e91f.jpg";